<script>
import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            input: '',
            placeholder: '',
            title: '',
        }
    },
    props: ['field', 'resourceInstance', 'value'],
    methods: {
        setValue() {
            this.resourceInstance.attributes[this.field.attribute] = this.input
        },
    },
    mounted() {
        if (this.value) this.input = this.value
        if (this.field.title) this.title = this.field.title
        if (this.field.placeholder) this.placeholder = this.field.placeholder
    },
})
</script>

<template>
    <div>
        <b-form-input v-b-tooltip.hover="title" v-model="input" @change="setValue" :placeholder="placeholder"></b-form-input>
    </div>
</template>

<style scoped></style>
